<template>
  <div class="view pa24">
    <el-form inline :model="form">
      <el-form-item :label="$t('addedServices', 'eachEnterprise')">
        <el-select
          v-model="form.dayType"
          :placeholder="$t('addedServices', 'pleaseSelect')"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            @change="dayType_tap"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'canFreePublish')">
        <el-input v-model="form.publishNum"></el-input>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'demandCount')">
        <el-input v-model="form.proNum"></el-input>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'productCount')">
        <el-button
          @click="saveSetting"
          style="background-color: #51cdcb; color: white"
          >{{ $t('addedServices', 'save') }}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18nMixin';
import { queryPublishSetting, updatePublishSetting } from "@/api/addedServices";
export default {
  mixins: [i18nMixin],
  data() {
    return {
      form: {
        dayType: "DAY",
        publishNum: 0,
        proNum: 0,
      },
      options: [
        {
          value: "DAY",
          label: this.$t('addedServices', 'daily'),
        },
        {
          value: "WEEK",
          label: this.$t('addedServices', 'weekly'),
        },
        {
          value: "MONTH",
          label: this.$t('addedServices', 'monthly'), 
        },
      ],
    };
  },
  created(){
    this.queryPublishSetting()
  },
  methods:{
   async queryPublishSetting(){
     const reslut = await queryPublishSetting({pageSize : 0},{ showLoading: true });
     console.log(reslut,'lwssb');
     this.form = reslut.data ? reslut.data : this.form ;
    },
   async saveSetting(){
      await updatePublishSetting(this.form);
      this.$message({
          message: this.$t('addedServices', 'saveSuccess'),
          type: "success",
        });
      this.queryPublishSetting()
    },
    dayType_tap(type){
      console.log(type)
    }
  }
};
</script>

<style lang="scss" scoped>
</style>